/**
 * Номер в ключе поднимают только при несовместимом изменении формата: старый черновик тогда не
 * прочитается. Новые поля номера не требуют — при восстановлении сохранённое сливается с пустыми
 * значениями, и заявка гостя, ушедшего регистрироваться, не теряется.
 */
const draftKey = 'fulfillment-request-draft-v1'
const databaseName = 'evirma-fulfillment-request-draft'
const storeName = 'files'
const filesKey = 'files'

/**
 * Черновик живёт в localStorage: он должен дождаться возвращения даже после закрытия вкладки.
 * Отказ хранилища (приватный режим, запрет данных сайта, кончилось место) не должен ронять
 * мастер — в худшем случае человек заполнит форму заново.
 */
export const saveDraftFields = (fields: unknown) => {
  try {
    localStorage.setItem(draftKey, JSON.stringify(fields))

    return true
  } catch {
    return false
  }
}

export const loadDraftFields = <T>() => {
  try {
    const saved = localStorage.getItem(draftKey)

    return saved === null ? null : (JSON.parse(saved) as T)
  } catch {
    return null
  }
}

export const clearDraftFields = () => {
  try {
    localStorage.removeItem(draftKey)
  } catch {
    // Убрать черновик не удалось: он просто дождётся следующей попытки.
  }
}

const openDatabase = () =>
  new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(databaseName, 1)
    request.onupgradeneeded = () => request.result.createObjectStore(storeName)
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })

/**
 * Ответ отдаём только после того, как транзакция зафиксирована: успех самого запроса ещё не
 * значит, что запись легла на диск, и уход со страницы сразу после вызова её отменит.
 */
const fileOperation = async <T>(mode: IDBTransactionMode, operation: (store: IDBObjectStore) => IDBRequest<T>) => {
  const database = await openDatabase()
  return new Promise<T>((resolve, reject) => {
    const transaction = database.transaction(storeName, mode)
    const request = operation(transaction.objectStore(storeName))
    request.onerror = () => reject(request.error)
    transaction.onabort = () => reject(transaction.error)
    transaction.oncomplete = () => {
      database.close()
      resolve(request.result)
    }
  })
}

/** Файлы заявки лежат одной записью: их всегда сохраняют и восстанавливают целым списком. */
export const saveDraftFiles = (files: File[]) => fileOperation('readwrite', (store) => store.put(files, filesKey))
export const loadDraftFiles = () => fileOperation<File[] | undefined>('readonly', (store) => store.get(filesKey))
export const clearDraftFiles = () => fileOperation('readwrite', (store) => store.delete(filesKey))
